// Simples exemplo de mixin; apenas exemplificando como reaproveitar código no Vue

/**
 * Função que de fato realiza um deep clone de um objeto
 * @param value Objeto a ser clonado
 * @returns {any} Retorna uma nova instância do objeto passado como parãmetro
 */
const cloneObject = (value) => {
  return JSON.parse(JSON.stringify(value))
}
export default ({
  dataKey = '',
  defaultValue = {}
}) => {
  return {
    methods: {
      /**
       * Método que realiza o reset dos campos de um formulário
       */
      resetFormHandler () {
        this.$v[dataKey].$reset()
        if (defaultValue) {
          this[dataKey] = typeof defaultValue === 'object' ? cloneObject(defaultValue) : defaultValue
        } else {
          Object.keys(this[dataKey]).forEach(attr => {
            this[dataKey][attr] = null
          })
        }
      },
      /**
       * Função que retorna bind de validações conforme o field passado
       * @param field field que consta na validação
       * @returns {{input: (function(): void|*), blur: (function(): void|*)}} Objeto com listerners que serão passados pros componentes
       */
      bindTouchEvents (field) {
        return {
          input: () => this.$v[dataKey][field].$touch(), // Sempre que o usuário realizar o input de algum valor vai forçar a validação
          blur: () => this.$v[dataKey][field].$touch() // Ao realizar o blur do campo irá forçar a validação do mesmo
        }
      }
    }
  }
}
